import { createFileRoute } from '@tanstack/react-router';

import { ArenaMain } from '@/features/arena/arena-session';
import { littlebirdSdk } from '@/lib/sdk-init';

export const Route = createFileRoute('/_authenticated/arena/$arenaId')({
  onEnter() {
    void littlebirdSdk.stores.arenas.ensureListLoadedFromStorage();
  },
  component: ArenaMain,
});
